"use client";

import {
    LayersIcon,
    BuildingIcon,
    BotIcon,
    FileSpreadsheetIcon,
    FileIcon,
    CreditCardIcon,
    BrainIcon,
} from "lucide-react";
import * as React from "react";
import { Link } from "react-router-dom";
import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar";
import { AppRoutes } from "@/types/routes";

const superAdminNavItems = [
    {
        title: "Sections",
        url: `/${AppRoutes.Admin}/${AppRoutes.Sections}`,
        icon: LayersIcon,
    },
    {
        title: "Tenants",
        url: `/${AppRoutes.Admin}/${AppRoutes.Tenants}`,
        icon: BuildingIcon,
    },
    {
        title: "AI",
        url: `/${AppRoutes.Admin}/${AppRoutes.Ai}`,
        icon: BotIcon,
    },
    {
        title: "Templates",
        url: `/${AppRoutes.Admin}/${AppRoutes.Templates}`,
        icon: FileSpreadsheetIcon,
    },
    {
        title: "Document Types",
        url: `/${AppRoutes.Admin}/${AppRoutes.DocumentTypes}`,
        icon: FileIcon,
    },
    {
        title: "Credit Actions",
        url: `/${AppRoutes.Admin}/${AppRoutes.CreditActions}`,
        icon: CreditCardIcon,
    },
    {
        title: "Assistant Items",
        url: `/${AppRoutes.Admin}/${AppRoutes.Assistant}`,
        icon: BrainIcon,
    },
];

export const NavSuperAdmin = ({
    ...props
}: React.ComponentPropsWithoutRef<typeof SidebarGroup>) => {
    return (
        <SidebarGroup {...props}>
            <SidebarGroupLabel>Super Admin</SidebarGroupLabel>
            <SidebarGroupContent>
                <SidebarMenu>
                    {superAdminNavItems.map(item => (
                        <SidebarMenuItem key={item.title}>
                            <SidebarMenuButton asChild>
                                <Link to={item.url}>
                                    <item.icon />
                                    <span>{item.title}</span>
                                </Link>
                            </SidebarMenuButton>
                        </SidebarMenuItem>
                    ))}
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    );
};
